import { CSSProperties } from 'react';
import { Stack, Slider, SliderProps } from '@mui/material';
import { Controller, Control, FieldValues } from 'react-hook-form';

import TextFormLabel from '../text/TextFormLabel';
import TextFormError from '../text/TextFormError';

export interface SliderFieldProps<T extends FieldValues = FieldValues> extends Omit<SliderProps, 'name' | 'control'> {
  name: string;
  control: Control<T>;
  label: string;
  required?: boolean;
  disabled?: boolean;
  style?: CSSProperties;
}

export const SliderField = <T extends FieldValues = FieldValues>(props: SliderFieldProps<T>) => {
  const { name, control, label, required = false, disabled = false, style, ...sliderProps } = props;

  return (
    <Stack spacing={0.5}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <TextFormLabel label={label} required={required} />
      </Stack>
      <Controller
        name={name as any}
        control={control}
        render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
          <>
            <Slider
              value={value ?? 0}
              onChange={(_, newValue) => onChange(newValue)}
              onBlur={onBlur}
              disabled={disabled}
              style={{
                maxWidth: '95%',
                ...style,
              }}
              {...sliderProps}
            />
            <TextFormError error={error} />
          </>
        )}
      />
    </Stack>
  );
};
